import axios from 'axios'
import { decryptUtil, encryptUtil } from '../Utils/decrypt';
const instance = axios.create({
    // baseURL: 'https://stagesp.taski.in/web'
    // baseURL: 'https://devsp.taski.in/web',
    baseURL:'https://sp.taski.in/web'
    // baseURL: 'http://192.168.2.235:8090/web', //Nidhin
    // baseURL: 'http://192.168.2.51:2029/web', //Nithish
    // baseURL: 'http://192.168.2.73:2027/web', //Sharon
})

const token = localStorage.getItem('vendorLoginToken');
if (token) instance.defaults.headers.common['token'] = token



instance.interceptors.response.use(
    (response) => {
        try {
            const decryptedData = new decryptUtil({ encrypted: response.data }).getDecryptedData();
            response.data = decryptedData;
        } catch (error) {
            console.log(error)
        }
        return response;
    },
    (error) => {
        const decryptedData = new decryptUtil({ encrypted: error.response.data }).getDecryptedData();
        error.response.data = decryptedData;
        return Promise.reject(error);
    }
);



instance.interceptors.request.use(
    async (config) => {
        const branch = JSON.parse(localStorage.getItem('selectedBranch'));
        if (branch) {
            config.headers['branch'] = branch.id;
        }
        if (config.data && !(config.data instanceof FormData)) {
            const encryptedPayload = new encryptUtil({ decrypt: config.data }).getEncryptedData();
            config.data = {
                data: encryptedPayload,
            };
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);



export default instance

